"use strict";

/**
 * @generated SignedSource<<16615c98a6b28a5ded60a77926f7d938>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "slug"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "slug",
      "variableName": "slug"
    }],
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    v3 = {
      "kind": "InlineFragment",
      "selections": [v2 /*: any*/, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dbId",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }],
      "type": "Supplier",
      "abstractKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "useSelectedGlobalSupplierFetchQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "supplier",
        "plural": false,
        "selections": [v3 /*: any*/],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "useSelectedGlobalSupplierFetchQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "supplier",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }, v3 /*: any*/, {
          "kind": "InlineFragment",
          "selections": [v2 /*: any*/],
          "type": "Node",
          "abstractKey": "__isNode"
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "b86f9b28a3dbe85be6dec1e6a7a3066c",
      "id": null,
      "metadata": {},
      "name": "useSelectedGlobalSupplierFetchQuery",
      "operationKind": "query",
      "text": "query useSelectedGlobalSupplierFetchQuery(\n  $slug: String!\n) {\n  supplier(slug: $slug) {\n    __typename\n    ... on Supplier {\n      id\n      dbId\n      slug\n      name\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
    }
  };
}();
node.hash = "d8f82fa238abcb6dfa84642bce9ca5a7";
export default node;